import React from 'react';
import { cn } from './_cn';

const SectionCard = ({
  title,
  description,
  actions,
  icon,
  children,
  noBodyPadding = false,
  // A section that IS the page needs no box: a border separates one object
  // from another, and there is nothing beside it to separate from. Flush
  // drops the box and the 20px inset with it, so the section's title and its
  // content read from the same left edge as the page header above them.
  // Opt-in — every existing caller keeps the card.
  flush = false,
  className = '',
  headerClassName = '',
  bodyClassName = '',
}) => {
  const hasHeader = Boolean(title || description || actions || icon);
  return (
    <section
      className={cn(
        'reveal overflow-hidden',
        flush
          ? ''
          : 'rounded-md border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800',
        className,
      )}
    >
      {hasHeader && (
        <div
          className={cn(
            'flex items-start justify-between gap-3 border-b border-slate-100 py-4 dark:border-slate-700',
            flush ? '' : 'px-5',
            headerClassName,
          )}
        >
          <div className="flex min-w-0 flex-1 items-start gap-3">
            {icon ? <div className="pt-0.5">{icon}</div> : null}
            <div className="min-w-0">
              {title ? (
                <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">
                  {title}
                </h2>
              ) : null}
              {description ? (
                <p className="mt-0.5 text-sm text-slate-500 dark:text-slate-400">
                  {description}
                </p>
              ) : null}
            </div>
          </div>
          {actions ? (
            <div className="flex shrink-0 items-center gap-2">{actions}</div>
          ) : null}
        </div>
      )}
      <div
        className={cn(
          noBodyPadding ? '' : flush ? 'py-5' : 'p-5',
          bodyClassName,
        )}
      >
        {children}
      </div>
    </section>
  );
};

export default SectionCard;
